// 中途採用(スタイリスト/アシスタント)モードで扱うポジションの定義。
// 新卒側の「年度」に相当する単位として、ポジションごとに求人・求人票データを分けて持つ。
// recruits/{companyId}_midCareer_{slug} (求人) / recruits/{companyId}/jobPostings/midCareer_{slug} (求人票)
// のIDに使われるため、slugの変更・削除は既存データとの不整合を招く。追加のみ想定。

export type MidCareerPositionSlug = 'stylist' | 'assistant';

export type MidCareerPosition = {
  slug: MidCareerPositionSlug;
  label: string;
};

export const MID_CAREER_POSITIONS: MidCareerPosition[] = [
  { slug: 'stylist', label: 'スタイリスト' },
  { slug: 'assistant', label: 'アシスタント' },
];

export function isMidCareerPositionSlug(value: string | undefined): value is MidCareerPositionSlug {
  return value === 'stylist' || value === 'assistant';
}

export function midCareerPositionLabel(slug: string | undefined): string {
  return MID_CAREER_POSITIONS.find((p) => p.slug === slug)?.label ?? '';
}

// 求人(3.recruit相当)のFirestoreドキュメントID。
// recruits/{recruitId} フラットドキュメント(firestore.rulesのhasExpectedRecruitId()で
// 明示的に許可されたIDのみ作成・更新できる)。
export function midCareerRecruitId(companyId: string, position: MidCareerPositionSlug): string {
  return `${companyId}_midCareer_${position}`;
}

// 求人票(2.jobPostings/edit相当)のサブコレクションドキュメントID。
// recruits/{companyId}/jobPostings/{id} は年度(2027, 2028...)と同じ場所に並ぶ。
export function midCareerJobPostingDocId(position: MidCareerPositionSlug): string {
  return `midCareer_${position}`;
}
